<template>
  <Collapse
    :title="$t('tenantProjects.managementFee')"
    v-if="canRead || isTenant"
    class="management-fee-margin-top"
  >
    <div
      class="projectControl__management-fee"
      slot="content"
    >
      <ManagementFeeAmount
        ref="managementFeeAmount"
        :canUpdate="canUpdate"
        :canNotifyAccounting="canNotifyAccounting"
        :canRead="canRead"
        @dirty-state-change="notifyDirtyStateChange"
      />
      <div
        v-show="!isTenant && isShowManagementAttachment"
        class="management-fee-upload"
      >
        <hr>
        <p
          v-if="isShowManagementAttachment"
          class="title blod-p"
        >{{ $t('tenantProjects.managementFeeDocTitle') }}
          <span class="internal">({{ $t('internalUseOnly') }})</span>
        </p>
        <HkldDropzone
          :sourceId="sourceId"
          v-if="sourceId && canUpdate"
        />
        <EditAttachments
          v-if="sourceId"
          ref="editAttachments"
          :sourceId="sourceId"
          :canDownloadAll="false"
          :canEdit="canUpdate"
          :canDelete="canUpdate"
          :getFilesList="getFilesList"
        />
      </div>
    </div>
  </Collapse>
</template>

<script>
import { mapGetters } from 'vuex'
import { get as _get } from 'lodash'

import Collapse from '@/controls/Collapse'
import ManagementFeeAmount from './ManagementFeeAmount'
import EditAttachments from '@/controls/EditAttachments'
import HkldDropzone from '@/controls/HkldDropzone'
import { aclHelper, tmsPermsTypes } from '@/utils/aclHelper'

export default {
  name: 'ManagementFeeIndex',
  components: {
    Collapse,
    ManagementFeeAmount,
    EditAttachments,
    HkldDropzone,
  },
  data () {
    return {
      filesLength: 0,
      chequeFiles: [],
    }
  },
  methods: {
    getFilesList (files) {
      this.filesLength = files.length
    },
    hasDirtySaveFields () {
      const component = this.$refs.managementFeeAmount
      return !!(component && component.hasDirtySaveFields && component.hasDirtySaveFields())
    },
    notifyDirtyStateChange () {
      this.$emit('dirty-state-change')
    },
    async saveAndContinueLeave ({ deferFinalize = false } = {}) {
      const component = this.$refs.managementFeeAmount
      if (!component) {
        return true
      }
      return component.saveAndContinue({ deferFinalize })
    },
  },
  computed: {
    ...mapGetters('user', ['isTenant']),
    ...mapGetters('tenantProject', ['currentTenantProject', 'management']),
    sourceId () {
      return _get(this.management, 'id')
    },
    canRead () {
      return aclHelper.getAccess(tmsPermsTypes.project.readDeposit)
    },
    canUpdate () {
      return aclHelper.getAccess(tmsPermsTypes.project.updateDeposit)
    },
    canNotifyAccounting () {
      return aclHelper.getAccess(tmsPermsTypes.project.notifyAccounting)
    },
    isShowManagementAttachment () {
      return this.canUpdate || (this.canRead && this.filesLength > 0)
    },
  },
}
</script>

<style lang='scss' scoped>
  .management-fee-margin-top {
    margin-top: 20px;
  }
  .projectControl__management-fee {
    padding: 20px;
    input[type="radio"] {
      cursor: pointer;
      height: 18px;
      width: 18px;
      display: inline-block;
      vertical-align: middle;
    }
    input {
      margin-bottom: 0px !important;
    }
    .management-fee-upload {
      p.title {
        margin-bottom: 15px;
      }
    }
  }
  .blod-p {
    font-weight: bold;
    margin-bottom: 0;
    height: 25px;
  }
  .medium-size {
    font-size: 16px !important;
  }
  .gray-font {
    font-size: 12px;
    color: #878787;
    display: inline-block;
    height: 20px
  }
  .margin-left-15 {
    margin-left: 15px;
  }
  .margin-right-15 {
    margin-right: 15px;
  }
</style>
